import React, { useContext, useEffect, useState } from 'react'
import {
  Footer,
  Search,
  SelectContainer,
  StyledTable,
  TableCell,
  TableContainer,
  TableHeader,
} from './styled'
import { Button } from '../../../../components/common/Button'
import { MagnifyingGlass, NotePencil } from '@phosphor-icons/react'
import { Input } from '../../../../components/common/Input'
import useFilteredData from '../../../../hooks/searchHook'
import { Select } from '../../../../components/common/Select'
import api from '../../../../services/api'
import { Context } from '../../../../context/context_employee'

export const EmployeesTable = ({ onclick, data }) => {
  const { filteredData, filterData } = useFilteredData(data)
  const [active, setActive] = useState('actives')
  const [search, setSearch] = useState('')
  const { handleGetTable } = useContext(Context)

  const handleSubmit = (e) => {
    e.preventDefault()
  }

  const handleSearchChange = (e) => {
    setSearch(e.target.value)
    filterData(e.target.value)
  }

  useEffect(() => {
    const isActive = active === 'actives' // Se for "actives", passa true, senão passa false
    handleGetTable(isActive)
  }, [active])

  return (
    <>
      <TableContainer>
        <div>
          <SelectContainer>
            <Select
              bordercolor="#CECECE"
              backgroundcolor="#f7f7f7"
              currentOption={active}
              label={{ title: '', htmlFor: '' }}
              onchange={(e) => setActive(e.target.value)}
              data={[
                { id: 'actives', value: 'Ver usuários ativos' },
                { id: 'inactives', value: 'Ver usuários inativos' },
              ]}
            />
          </SelectContainer>
          <Search onSubmit={handleSubmit}>
            <span>Pesquisar</span>
            <Input.Root>
              <Input.Wrapper
                borderColor="#CECECE"
                backgroundColor="#F7F7F7"
                outlineColor=""
              >
                <Input.Content
                  id=""
                  onChange={handleSearchChange}
                  type="text"
                  value={search}
                  placeholder="Usuário"
                />
                <Input.Icon>
                  <MagnifyingGlass size={16} color="#494949" />
                </Input.Icon>
              </Input.Wrapper>
            </Input.Root>
          </Search>
        </div>

        <StyledTable>
          <thead>
            <tr>
              <TableHeader>Nome de usuário</TableHeader>
              <TableHeader>Base</TableHeader>
              <TableHeader>Posto</TableHeader>
              <TableHeader>categoria</TableHeader>
              <TableHeader>Sempre alerta</TableHeader>
              <TableHeader>Acesso</TableHeader>
              <TableHeader>Status</TableHeader>
              <TableHeader>Editar dados</TableHeader>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((data) => {
              return (
                <tr key={data.id}>
                  <TableCell>{data.name}</TableCell>
                  <TableCell>{data.base}</TableCell>
                  <TableCell>{data.outpost}</TableCell>
                  <TableCell>{data.role}</TableCell>
                  <TableCell>
                    <>
                      <span
                        color={
                          data.always_alert_response === 'Não respondido'
                            ? '#770A00'
                            : '#000'
                        }
                      >
                        {data.always_alert_response}
                      </span>
                    </>
                  </TableCell>

                  <TableCell>{data.login}</TableCell>
                  <TableCell>
                    <Button.Root
                      backgroundColor={
                        data.status === 'Online' ? '#665396' : '#D92F18'
                      }
                      type="button"
                    >
                      <Button.Content title={data.status} color="#fff" />
                    </Button.Root>
                  </TableCell>
                  <TableCell>
                    <Button.Root
                      onClick={() => onclick(data.id)}
                      backgroundColor="#00517D"
                      type="button"
                    >
                      <Button.Content title="Editar" color="#fff" />
                      <Button.Icon>
                        <NotePencil size={18} color="#fff" weight="fill" />
                      </Button.Icon>
                    </Button.Root>
                  </TableCell>
                </tr>
              )
            })}
          </tbody>
        </StyledTable>
        <Footer>
          <span>{`Listando ${filteredData.length} usuários`}</span>
        </Footer>
      </TableContainer>
    </>
  )
}
